import type {
  EgressLinkListEntry,
  EgressNodeTrafficRow,
  EgressPathSnapshotRow,
  EgressPathSwitchEventRecord,
  ListEgressLinksResponse,
  ListEgressNodeTrafficResponse,
  ListEgressPathSnapshotsResponse,
  ListEgressPathSwitchEventsResponse,
  ListReplicationHealthResponse,
  PatchEgressLinkDispatchRequest,
  PatchEgressLinkDispatchResponse,
  PatchEgressLinkStatusRequest,
  PatchEgressLinkStatusResponse,
  ReplicationHealthSample,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE = '/v1/ops/egress';

export async function listEgressLinks(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<readonly EgressLinkListEntry[]> {
  const response = await opsApiRequest<ListEgressLinksResponse>(
    `${BASE}/links`,
    { signal },
    fetchImpl,
  );
  return response.links;
}

export async function listEgressSnapshots(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<readonly EgressPathSnapshotRow[]> {
  const response = await opsApiRequest<ListEgressPathSnapshotsResponse>(
    `${BASE}/snapshots`,
    { signal },
    fetchImpl,
  );
  return response.snapshots;
}

export async function listEgressSwitchEvents(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
  limit?: number,
): Promise<readonly EgressPathSwitchEventRecord[]> {
  const suffix = limit === undefined ? '' : `?limit=${encodeURIComponent(String(limit))}`;
  const response = await opsApiRequest<ListEgressPathSwitchEventsResponse>(
    `${BASE}/switch-events${suffix}`,
    { signal },
    fetchImpl,
  );
  return response.events;
}

export async function listEgressNodeTraffic(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<readonly EgressNodeTrafficRow[]> {
  const response = await opsApiRequest<ListEgressNodeTrafficResponse>(
    `${BASE}/nodes`,
    { signal },
    fetchImpl,
  );
  return response.nodes;
}

export async function listReplicationHealth(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<readonly ReplicationHealthSample[]> {
  const response = await opsApiRequest<ListReplicationHealthResponse>(
    `${BASE}/replication-health`,
    { signal },
    fetchImpl,
  );
  return response.links;
}

export async function patchEgressLinkStatus(
  egressId: string,
  body: PatchEgressLinkStatusRequest,
  fetchImpl: typeof fetch,
): Promise<PatchEgressLinkStatusResponse> {
  return opsApiRequest<PatchEgressLinkStatusResponse>(
    `${BASE}/links/${encodeURIComponent(egressId)}/status`,
    { method: 'PATCH', body },
    fetchImpl,
  );
}

export async function patchEgressLinkDispatch(
  egressId: string,
  body: PatchEgressLinkDispatchRequest,
  fetchImpl: typeof fetch,
): Promise<PatchEgressLinkDispatchResponse> {
  return opsApiRequest<PatchEgressLinkDispatchResponse>(
    `${BASE}/links/${encodeURIComponent(egressId)}`,
    { method: 'PATCH', body },
    fetchImpl,
  );
}
